// Silence all console output in production builds (browser only)
if (typeof window !== 'undefined' && import.meta.env && import.meta.env.PROD) {
  const noop = () => {};
  const methodNames = [
    'log',
    'info',
    'warn',
    'debug',
    'error',
    'trace',
    'group',
    'groupCollapsed',
    'groupEnd',
    'time',
    'timeEnd',
    'table',
    'assert',
  ] as const;
  const c: any = window.console || {};
  for (const name of methodNames) {
    try {
      // Preserve originals for potential future debugging hooks
      const original = c[name];
      (c as any)[`__original_${name}`] = typeof original === 'function' ? original.bind(c) : original;
      c[name] = noop;
    } catch {
      // Ignore assignments that fail (some environments may lock console methods)
    }
  }
}


